import { apiClient } from './api';

/**
 * Apps Service
 * Handles all apps-related API calls
 */
export const appsService = {
  /**
   * Get apps list
   * @param {Object} params - Query parameters
   * @param {number} params.account_id - Account ID (optional)
   * @param {string} params.platform - Filter by platform: 'iOS' or 'Android' (optional)
   * @param {string} params.status - Filter by status: 'active' or 'inactive' (optional)
   * @param {string} params.search - Search by app name (optional)
   * @param {string} params.sort_by - Sort field: 'name', 'creation_date', 'last_sync' (default: 'name')
   * @param {string} params.sort_order - Sort order: 'ASC' or 'DESC' (default: 'ASC')
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.per_page - Items per page (default: 20, max: 100)
   * @param {boolean} params.sync - Force sync from IronSource API (default: true)
   * @returns {Promise} Apps list data
   */
  getApps: (params = {}) => {
    return apiClient.get('/apps', params);
  },

  /**
   * Get app details
   * @param {string} appKey - App key
   * @param {Object} params - Query parameters
   * @param {number} params.account_id - Account ID (optional)
   * @param {string} params.start_date - Start date for performance summary (optional)
   * @param {string} params.end_date - End date for performance summary (optional)
   * @returns {Promise} App details data
   */
  getAppDetails: (appKey, params = {}) => {
    return apiClient.get(`/apps/${appKey}`, params);
  },

  /**
   * Get app ad units
   * @param {string} appKey - App key
   * @param {Object} params - Query parameters
   * @param {number} params.account_id - Account ID (optional)
   * @returns {Promise} App ad units data
   */
  getAppAdUnits: (appKey, params = {}) => {
    return apiClient.get(`/apps/${appKey}/ad-units`, params);
  },

  /**
   * Get app networks
   * @param {string} appKey - App key
   * @param {Object} params - Query parameters
   * @param {number} params.account_id - Account ID (optional)
   * @param {string} params.ad_unit - Filter by ad unit type (optional)
   * @returns {Promise} App networks data
   */
  getAppNetworks: (appKey, params = {}) => {
    return apiClient.get(`/apps/${appKey}/networks`, params);
  },
};
